import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 flex flex-col">
      <div className="flex-1">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-8">
            <ArrowLeft className="w-4 h-4" />
            Back to home
          </Link>
        
          <div className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 bg-emerald-700 rounded-xl flex items-center justify-center">
              <MessageSquare className="w-6 h-6 text-white" />
            </div>
            <span className="font-bold text-2xl text-slate-900 dark:text-white">Flowteras</span>
          </div>
        
          <h1 className="text-4xl font-bold text-slate-900 dark:text-white mb-8" data-testid="privacy-title">
            Privacy Policy
          </h1>
        
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <p className="text-slate-600 dark:text-slate-400">Last updated: April 2026</p>

            <div className="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg p-6 my-8" data-testid="privacy-entity-attribution">
              <p className="text-slate-800 dark:text-slate-200 font-medium">
                Flowteras is a product of GREENMOUNT SOLUTIONS SDN. BHD. (Registration No: 202401025006 (1570855-W)), a company incorporated in Malaysia.
              </p>
            </div>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">1. Information We Collect</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              We collect information you provide directly to us, such as when you create an account, use our services, or contact us for support. This includes:
            </p>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 space-y-2 mb-6">
              <li>Account information (name, email, organization name)</li>
              <li>WhatsApp Business API credentials</li>
              <li>Conversation data processed through our platform</li>
              <li>Usage data and analytics</li>
            </ul>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 space-y-2 mb-6">
              <li>Provide, maintain, and improve our services</li>
              <li>Process and complete transactions</li>
              <li>Send technical notices and support messages</li>
              <li>Train and improve our AI models</li>
            </ul>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">3. Data Security</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              We implement appropriate technical and organizational measures to protect your personal data against unauthorized or unlawful processing, accidental loss, destruction, or damage.
            </p>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">4. Data Retention</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected, including to satisfy legal, accounting, or reporting requirements.
            </p>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">5. Your Rights</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc list-inside text-slate-600 dark:text-slate-400 space-y-2 mb-6">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
            </ul>
          
            <h2 className="text-2xl font-semibold text-slate-900 dark:text-white mt-8 mb-4">6. Contact Us</h2>
            <p className="text-slate-600 dark:text-slate-400 mb-6">
              If you have any questions about this Privacy Policy, please contact us at privacy@flowteras.com.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
